import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const serverUrl = "/api";

const PartnerChangePassword = () => {
    const { t } = useTranslation();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChangePassword = async (e) => {
        e.preventDefault();
        setError('');

        if (newPassword !== confirmPassword) {
            setError(t('passwords_not_matching', 'Passwords do not match'));
            return;
        }

        const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/;
        if (!passwordRegex.test(newPassword)) {
            setError(t('password_complexity_error', 'Password must be at least 6 characters long and contain at least 1 number and 1 letter'));
            return;
        }

        const token = localStorage.getItem('partner_temp_token');
        if (!token) {
            navigate('/partner');
            return;
        }

        setLoading(true);
        try {
            const res = await fetch(serverUrl + '/partner/change-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ token, newPassword })
            });
            if (res.ok) {
                // Password changed successfully. Force them to login again with the new password.
                localStorage.removeItem('partner_temp_token');
                navigate('/partner');
            } else {
                const data = await res.json();
                setError(data.error || 'Failed to change password');
            }
        } catch (err) {
            setError('Server error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f4f4f4' }}>
            <form onSubmit={handleChangePassword} style={{ background: '#fff', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)', width: '350px', display: 'flex', flexDirection: 'column' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '10px', color: '#a239ca' }}>Change Password</h2>
                <p style={{ textAlign: 'center', marginBottom: '20px', color: '#666', fontSize: '14px' }}>Please change your default password before accessing the dashboard.</p>
                <input 
                    type="password" 
                    placeholder="New Password" 
                    value={newPassword} 
                    onChange={e => setNewPassword(e.target.value)} 
                    style={{ padding: '10px', marginBottom: '15px', borderRadius: '5px', border: '1px solid #ccc' }} 
                    required 
                />
                <input 
                    type="password" 
                    placeholder="Confirm New Password" 
                    value={confirmPassword} 
                    onChange={e => setConfirmPassword(e.target.value)} 
                    style={{ padding: '10px', marginBottom: '15px', borderRadius: '5px', border: '1px solid #ccc' }} 
                    required 
                />
                <button type="submit" disabled={loading} style={{ padding: '10px', backgroundColor: '#a239ca', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>
                    {loading ? 'Updating...' : 'Change Password'}
                </button>
                {error && <p style={{ color: 'red', fontSize: '12px', marginTop: '15px', textAlign: 'center' }}>{error}</p>}
            </form>
        </div>
    );
};

export default PartnerChangePassword;
